import { Routes } from '@angular/router';
import { ProcessListComponent } from './pages/process-list/process-list.component';
import { ProcessDetailComponent } from './pages/process-detail/process-detail.component';
import { ProcessReviewComponent } from './pages/process-review/process-review.component';
import { RoleGuard } from '../core/guards/auth.guard';
import { Permission } from '../core/models/role-permissions.models';
import { RouteDataKey } from '../core/utils/route-snapshot.util';

export default [
	{
		path: '',
		loadComponent: () => ProcessListComponent,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.PROCESS_VIEW],
			comeback: 'panel',
		},
	},
	{
		path: 'detail/:id',
		loadComponent: () => ProcessDetailComponent,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.PROCESS_VIEW],
			comeback: 'processes',
			/** Precarga `view=initial` en privateGuard (NIF-368). */
			[RouteDataKey.PrefetchProcessDetailInitial]: true,
		},
	},
	{
		path: 'review',
		loadComponent: () => ProcessReviewComponent,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.PROCESSES_VALIDATE],
			comeback: 'processes',
		},
	},
	{
		path: 'review/:id',
		loadComponent: () => ProcessReviewComponent,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.PROCESSES_VALIDATE],
			comeback: 'processes',
		},
	},
] as Routes;
